<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12">
        <v-img :src="tableImg.val" class="mr-2 customImg">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="25vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">جزئیات پرونده</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="8" class="mt-5">
              <v-row>
                <!-- <v-spacer></v-spacer> -->
                <v-col class="mr-n9">
                  <v-btn icon dark class="darkColor mr-n16 mt-n2" @click="backToFollowUpMission">
                    <v-icon color="white">mdi-arrow-right mdi-18px</v-icon>
                  </v-btn>
                </v-col>
                <v-col class="text-center">
                  <span @click="changeTab(1)" :class="tab1Class">اطلاعات و ارزیابی اولیه</span>
                </v-col>
                <v-col class="text-center">
                  <span @click="changeTab(2)" :class="tab2Class"> اطلاعات تکمیلی</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="79vh" elevation="0" class="card-width body-card mt-3">
                <v-card-text>
                  <v-row>
                    <v-col cols="2" v-if="followUpPatientTab == '1'">
                      <v-row class="mt-16 mr-5">
                        <v-col cols="12" v-for="(item, index) in tab1Steps" :key="index">
                          <v-row>
                            <span :class="item.borderClass" @click="changeTab1Step(item.id, item.isActive)">
                              <h6 :class="item.stepClass">
                                <h1 :class="item.textClass" v-if="item.state == 'active'">
                                  {{ item.text }}
                                </h1>
                                <v-icon :class="item.textClass" v-else-if="item.state == 'deactive'">
                                  mdi-close mdi-18px
                                </v-icon>
                                <v-icon :class="item.textClass" color="white" v-else-if="item.state == 'finish'">
                                  mdi-check mdi-18px
                                </v-icon>
                              </h6>
                            </span>
                            <span :class="item.insideClass" @click="changeTab1Step(item.id, item.isActive)">
                              {{ item.insideText }}
                            </span>
                          </v-row>
                          <v-row v-if="item.showHR">
                            <hr :class="item.hrClass" />
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="10" v-if="followUpPatientTab == '1'">
                      <v-row>
                        <v-col cols="12" v-if="tab1step == '1'" class="main-side">
                          <follow-up-patient-step-1-component v-if="tab1step == '1'" :patientId="patientId"
                            :missionPhoneId="missionPhoneId"></follow-up-patient-step-1-component>
                        </v-col>
                        <v-col cols="12" v-if="tab1step == '2'">
                          <follow-up-patient-step2-component v-if="tab1step == '2'"
                            :patientId="patientId"></follow-up-patient-step2-component>
                        </v-col>
                        <v-col cols="12" v-if="tab1step == '3'">
                          <follow-up-patient-step3-component :patientId="patientId"
                            v-if="tab1step == '3'"></follow-up-patient-step3-component>
                        </v-col>
                      </v-row>
                    </v-col>
                    <template v-if="followUpPatientTab == '2'">
                      <report-form-follow-up :patientId="patientId" :missionPhoneId="missionPhoneId"
                        :missionType="missionMainType"></report-form-follow-up>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';

import FollowUpPatientStep1Component from '@/components/FollowUp/FollowUpPatientStep1Component.vue';
import FollowUpPatientStep2Component from '@/components/FollowUp/FollowUpPatientStep2Component.vue';
import FollowUpPatientStep3Component from '@/components/FollowUp/FollowUpPatientStep3Component.vue';
import ReportFormFollowUp from './ReportFormFollowUp.vue';


// import FollowUpPatientStep4Component from '@/components/FollowUp/FollowUpPatientStep4Component.vue';
// import FollowUpPatientStep5Component from '@/components/FollowUp/FollowUpPatientStep5Component.vue';
// import FollowUpPatientStep6Component from '@/components/FollowUp/FollowUpPatientStep6Component.vue';
// import FollowUpPatientStep7Component from '@/components/FollowUp/FollowUpPatientStep7Component.vue';
// import FollowUpPatientStep8Component from '@/components/FollowUp/FollowUpPatientStep8Component.vue';
// import FollowUpPatientStep9Component from '@/components/FollowUp/FollowUpPatientStep9Component.vue';
// import FollowUpPatientStep10Component from '@/components/FollowUp/FollowUpPatientStep10Component.vue';
// import FollowUpPatientStep11Component from '@/components/FollowUp/FollowUpPatientStep11Component.vue';
// import FollowUpPatientStep12Component from '@/components/FollowUp/FollowUpPatientStep12Component.vue';
// import FollowUpPatientStep13Component from '@/components/FollowUp/FollowUpPatientStep13Component.vue';
// import FollowUpPatientStep14Component from '@/components/FollowUp/FollowUpPatientStep14Component.vue';
import AlertComponent from '../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import FollowUpPatientHelper from '@/Helpers/FollowUp/FollowUpPatientHelper';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'FollowUpPatient',
  title: 'مددجو',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    FollowUpPatientStep1Component,
    FollowUpPatientStep2Component,
    FollowUpPatientStep3Component,
    ReportFormFollowUp,

    // FollowUpPatientStep4Component,
    // FollowUpPatientStep5Component,
    // FollowUpPatientStep6Component,
    // FollowUpPatientStep7Component,
    // FollowUpPatientStep8Component,
    // FollowUpPatientStep9Component,
    // FollowUpPatientStep10Component,
    // FollowUpPatientStep11Component,
    // FollowUpPatientStep12Component,
    // FollowUpPatientStep13Component,
    // FollowUpPatientStep14Component,
  },
  mixins: [FollowUpPatientHelper, ShearedMixin, snackBar],
  data() {
    return {
      encryptMissionPhoneId: null,
    };
  },
  created() {
    this.$root.$refs.FollowUpPatient = this;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      let id = this.$route.params.id;
      let missionPhoneId = '';
      if (id.includes('$$')) {
        let routeInfo = id.split('$$');
        let patientId = '';
        this.encryptMissionPhoneId = routeInfo[1];
        let bytes1 = CryptoJS.AES.decrypt(routeInfo[1], 'sA3r5r2Dfr7lyf8N');
        if (bytes1.sigBytes != 0) {
          patientId = JSON.parse(bytes1.toString(CryptoJS.enc.Utf8));
        } else {
          patientId = '';
        }
        this.patientId = Number(patientId);
        let bytes = CryptoJS.AES.decrypt(routeInfo[0], 'sA3r5r2Dfr7lyf8N');
        if (bytes.sigBytes != 0) {
          missionPhoneId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
          missionPhoneId = '';
        }
        this.missionPhoneId = Number(missionPhoneId);
      } else {
        this.encryptMissionPhoneId = id;
        let bytes = CryptoJS.AES.decrypt(id, 'sA3r5r2Dfr7lyf8N');
        if (bytes.sigBytes != 0) {
          missionPhoneId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
          missionPhoneId = '';
        }
      }
      this.missionPhoneId = Number(missionPhoneId);
      this.followUpPatientTab = 1;
    },
    backToFollowUpMission: function () {
      let id = this.missionPhoneId.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr5r2Dfr7lyf8N').toString();
      this.$router.push({ name: 'followUpMission', params: { id: encryptId } });
    },
  },
};
</script>
<style scoped>
/* :v-deep .customImg .v-image__image--cover {
  background-position: center right !important;
} */

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

/*tabs*/
.active-tab {
  color: var(--dark-color) !important;
  font-size: 15px !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
  border-bottom: 2px solid var(--dark-color) !important;
  cursor: pointer;
}

.deactive-tab {
  color: #212121 !important;
  font-size: 15px !important;
  cursor: pointer;
}

.active-step-border {
  border: 2px solid var(--dark-color) !important;
  border-radius: 50% !important;
  padding: 3px !important;
}

.active-step {
  background: var(--dark-color) !important;
  width: 4vh !important;
  height: 4vh !important;
  border-radius: 50% !important;
}

.deactive-step {
  background: #eaeaea !important;
  width: 4.8vh !important;
  height: 4.8vh !important;
  border-radius: 50% !important;
}

.finish-step {
  background: #3bca79 !important;
  width: 4.8vh !important;
  height: 4.8vh !important;
  border-radius: 50% !important;
}

.step-text {
  color: white !important;
  margin-right: 40% !important;
  padding-top: 20% !important;
  font-size: 15px !important;
}

.deactive-step-text {
  margin-right: 28% !important;
  padding-top: 27% !important;
}

.finish-step-text {
  margin-right: 28% !important;
  padding-top: 27% !important;
}

.active-step-inside-text {
  color: #212121;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.deactive-step-inside-text {
  color: #808080;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
}

.finish-step-inside-text {
  color: #808080;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
}

.tab-active-divider {
  border-right: 2px solid var(--dark-color) !important;
  border-top: none;
  border-left: none;
  border-bottom: none;
  height: 8vh !important;
  margin-right: 2.5vh !important;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.tab-deactive-divider {
  border-right: 2px solid #eaeaea !important;
  border-top: none;
  border-left: none;
  border-bottom: none;
  height: 8vh !important;
  margin-right: 2.5vh !important;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.tab-finish-divider {
  border-right: 2px solid #3bca79 !important;
  border-top: none;
  border-left: none;
  border-bottom: none;
  height: 8vh !important;
  margin-right: 2.5vh !important;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.main-side {
  height: 75vh !important;
  overflow-y: auto;
}
</style>
